module.exports = __webpack_public_path__ + "img/tiktok.abbb8884.svg";